export default "__VITE_ASSET__2d7dda3e__"